import React from "react";
import LegalLayout from "./LegalLayout";

const InterestRatePolicy = () => (
  <LegalLayout
    title="Interest Rate Policy"
    subtitle="Pawansut Holdings Limited — Transparent pricing"
  >
    <p className="last-updated">Last updated: February 2025</p>
    <p className="intro">
      Pawansut Holdings Limited (&quot;Company&quot;) follows a transparent and
      risk-based approach to interest rate pricing for its lending products, in
      line with RBI guidelines for NBFCs. This Interest Rate Policy outlines
      the broad principles governing how we determine and communicate interest
      rates to our customers.
    </p>

    <section>
      <h2>1. Objective</h2>
      <p>
        The objective of this policy is to ensure that interest rates and other
        charges are determined in a fair, consistent, and transparent manner,
        reflecting the cost of funds, operational costs, risk premium, and
        regulatory requirements, while remaining competitive and aligned with
        market conditions.
      </p>
    </section>

    <section>
      <h2>2. Factors Considered</h2>
      <p>Interest rates for our loan products are influenced by:</p>
      <ul>
        <li><strong>Cost of funds:</strong> Cost of borrowing and deployment of capital</li>
        <li><strong>Tenure and product type:</strong> Short-term vs long-term; secured vs unsecured</li>
        <li><strong>Credit risk:</strong> Assessment of borrower profile, repayment capacity, and collateral (if any)</li>
        <li><strong>Operational cost:</strong> Administrative and servicing costs</li>
        <li><strong>Regulatory and margin:</strong> Reserve requirements and sustainable margins</li>
        <li><strong>Market conditions:</strong> Prevailing rates and competition</li>
      </ul>
    </section>

    <section>
      <h2>3. Disclosure to Customers</h2>
      <p>
        We disclose the rate of interest (annualised), method of application
        (e.g. reducing balance), and all other charges in the sanction letter
        and loan agreement. Interest and charges are also communicated in
        application forms and on our website where applicable. We do not
        charge any hidden interest or fees; all components are clearly stated
        before the customer accepts the loan.
      </p>
    </section>

    <section>
      <h2>4. Fixed vs Floating Rates</h2>
      <p>
        Depending on the product, we may offer fixed or floating rate loans.
        For floating rate products, the basis of reset (e.g. internal benchmark
        or external benchmark as per RBI guidelines) and frequency of reset are
        clearly disclosed. Any change in rate is communicated in advance as per
        the terms of the agreement.
      </p>
    </section>

    <section>
      <h2>5. Penal and Other Charges</h2>
      <p>
        Penal interest or charges for default, bounce, or other specified events
        are disclosed in the loan agreement and as per our Fair Practice Code.
        Such charges are applied in a non-discriminatory manner as per the
        agreed terms.
      </p>
    </section>

    <section>
      <h2>6. Review and Approval</h2>
      <p>
        The Board of Directors or a duly constituted committee approves the
        broad framework of interest rate pricing. Operational decisions on
        product-wise rates are made within this framework and in compliance
        with RBI regulations.
      </p>
    </section>

    <section>
      <h2>7. No Discrimination</h2>
      <p>
        Rates are applied based on objective criteria related to product, risk,
        and tenure. We do not discriminate on the basis of gender, religion,
        or other impermissible factors as per law.
      </p>
    </section>

    <section>
      <h2>8. Grievances</h2>
      <p>
        Any complaint regarding interest rates, disclosure, or related charges
        may be raised through our Grievance Redressal mechanism as set out in
        our Grievance Redressal Policy.
      </p>
    </section>

    <section>
      <h2>9. Review of Policy</h2>
      <p>
        This Interest Rate Policy is reviewed periodically and updated to align
        with RBI guidelines and business requirements. The policy is available
        on our website for reference.
      </p>
    </section>
  </LegalLayout>
);

export default InterestRatePolicy;
